$(document).ready(function () {

	document.querySelectorAll('select[data-depends]').forEach((childSelect) => {
		let parentSelect = childSelect.form[childSelect.dataset.depends]; // parent <select>
		let url = childSelect.dataset.url; // attribute data-url
		let items = JSON.parse(childSelect.dataset.items || 'null'); // původní formát objektu s klíči: data-items
		let itemsSorted = JSON.parse(childSelect.dataset.itemssorted || 'null'); // nový formát pole objektů: data-itemsSorted
		let disableEmpty = childSelect.dataset.disableempty; // attribute data-disableempty
		let disabled = childSelect.dataset.disabled; // attribute data-disabled
		let disabledItemIds = JSON.parse(childSelect.dataset.disableditemids || '[]'); // attribute data-disabledItemIds
		let selectedValue = JSON.parse(childSelect.dataset.selectedvalue || 'null'); // attribute data-selectedvalue
		let multiselect = childSelect.dataset.multiselect;

		// Při změně rodičovského selectu
		parentSelect.addEventListener('change', () => {
			if (itemsSorted) {
				// Použití nového formátu - pole objektů
				updateSelectbox(childSelect, itemsSorted[parentSelect.value] || [], disableEmpty, disabled, disabledItemIds, selectedValue, false, multiselect);
			} else if (items) {
				// Původní logika pro starý formát
				updateSelectbox(childSelect, items[parentSelect.value], disableEmpty, disabled, disabledItemIds, selectedValue, false, multiselect);
			}

			if (url) {
				fetch(url.replace(encodeURIComponent('#'), encodeURIComponent(parentSelect.value)))
				.then((response) => response.json())
				.then((data) => updateSelectbox(childSelect, data, disableEmpty, disabled, disabledItemIds, selectedValue, false, multiselect));
			}
		});

		// První volání
		if (itemsSorted) {
			updateSelectbox(childSelect, itemsSorted[parentSelect.value] || [], disableEmpty, disabled, disabledItemIds, selectedValue, true, multiselect);
		} else {
			updateSelectbox(childSelect, items && items[parentSelect.value] ? items[parentSelect.value] : [], disableEmpty, disabled, disabledItemIds, selectedValue, true, multiselect);
		}
	});

	// replaces <options> in <select>
	function updateSelectbox(select, items, disableEmpty, disabled, disabledItemIds, selectedValue, firstCall, multiselect) {
		select.innerHTML = '';
		let selectedValueIndex = null;
		let selectedValuesArrayIndex = [];
		let itemIndex = 0;

		if (Array.isArray(items)) {
			// Nový formát - pole objektů [{id: ..., name: ...}]
			items.forEach((item) => {
				let el = document.createElement('option');
				el.setAttribute('value', item.id);

				if (disabledItemIds.length && disabledItemIds.includes(parseInt(item.id))) {
					el.setAttribute('disabled', 'true');
				}

				el.innerText = item.name;
				select.appendChild(el);

				if (selectedValue && item.id.toString() === selectedValue.toString()) {
					selectedValueIndex = itemIndex;
				}

				if (selectedValue && Array.isArray(selectedValue) && selectedValue.includes(parseInt(item.id))) {
					selectedValuesArrayIndex.push(itemIndex);
				}

				itemIndex++;
			});
		} else if (items && typeof items === 'object') {
			// Původní formát - objekt s klíči {"key": "value"}
			for (let key in items) {
				let el = document.createElement('option');
				el.setAttribute('value', key);

				if (disabledItemIds.length && disabledItemIds.includes(parseInt(key))) {
					el.setAttribute('disabled', 'true');
				}

				el.innerText = items[key];
				select.appendChild(el);

				if (selectedValue && key.toString() === selectedValue.toString()) {
					selectedValueIndex = itemIndex;
				}

				if (selectedValue && Array.isArray(selectedValue) && selectedValue.includes(parseInt(key))) {
					selectedValuesArrayIndex.push(itemIndex);
				}

				itemIndex++;
			}
		}

		// Zbytek funkce zůstává stejný
		if (disableEmpty !== undefined) {
			if (items === undefined || (Array.isArray(items) ? items.length === 0 : Object.keys(items || {}).length === 0)) {
				select.setAttribute('disabled', 'disabled');
			} else {
				select.removeAttribute('disabled');
			}
		}

		if (disabled !== undefined) {
			select.setAttribute('disabled', 'disabled');
		}

		if (multiselect !== undefined) {
			if (selectedValuesArrayIndex.length) {
				selectedValuesArrayIndex.forEach(function (currentElement, index, array) {
					select.options[currentElement].selected = true;
				});
			}
		} else {
			select.selectedIndex = selectedValueIndex ?? 0;
		}

		const event = new Event('change');
		select.dispatchEvent(event);

		if (window.jQuery && typeof refreshSelect2Multiple === 'function') {
			refreshSelect2Multiple(select.form || document);
		}
	}

});
